import React, { useContext, useEffect, useState } from 'react';
import Swal from "sweetalert2";
import './footer.css';
import { footerData } from '../../json/footer';
import { LanguageContext } from '../../context/LanguageContext/LanguageContext';
import Input from '../Elements/Inputs/Input';
import useForm from '../Hooks/UseForm';
import { COTIZACION_FORM } from '../Constants/Forms/Cotizacion';
import { cotizacionSchema } from '../Models/Forms/cotizacionSchema';
import { setErrorFormSimpleUtil } from '../Utilities/Forms/errors';
import Button from '../Elements/Buttons/Button';

const Footer = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { language } = useContext(LanguageContext);
  const data = footerData[language || 'ES'];
  const [isClient, setIsClient] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    isValid,
    resetForm,
  } = useForm(COTIZACION_FORM, cotizacionSchema);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  const currentYear = new Date().getFullYear();
  const bottomText = data.bottomText?.replace('{{year}}', currentYear);

  const handleSubmit = async (values) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/prd/sendEmail`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(values),
        }
      );
      const result = await response.json();

      if (response.ok) {
        resetForm();
        await Swal.fire({
          icon: "success",
          title: "¡Enviado con éxito!",
          text: "Tu mensaje ha sido enviado correctamente.",
          confirmButtonColor: "#1226AA",
          confirmButtonText: "Aceptar"
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error al enviar",
          text: result.message || "Ocurrió un error al enviar tu mensaje.",
          confirmButtonColor: "#d33",
          confirmButtonText: "Cerrar"
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No pudimos conectar con el servidor.",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer container-fluid">
      <div className="footer-top">
        <h2>
          {data.topSection.title}
          <span>{data.topSection.highlight}</span>
        </h2>
        <p>
          <span> {data.topSection.phone}</span>
          <a href={`mailto:${data.topSection.email}`}>{data.topSection.email}</a>
        </p>
      </div>
      <div className="footer-content row">
        <div className="footer-left col-md-3">
          <div
            className="footer-logo"
            style={{
              backgroundImage: `url(${data.leftSection.logo})`
            }}
          />
        </div>
        <div className="footer-form col-md-3">
          <h3 dangerouslySetInnerHTML={{ __html: data.formSection.title }}></h3>
          <div>
            <Input
              placeholder={data.formSection.fields.namePlaceholder}
              variant="Simple"
              value={values.name}
              onChange={handleChange("name")}
              onBlur={handleBlur("name")}
              error={setErrorFormSimpleUtil(errors, touched, "name")}
              success={!setErrorFormSimpleUtil(errors, touched, "name")}
            />

            <Input
              placeholder={data.formSection.fields.emailPlaceholder}
              variant="Simple"
              value={values.email}
              onChange={handleChange("email")}
              onBlur={handleBlur("email")}
              error={setErrorFormSimpleUtil(errors, touched, "email")}
              success={!setErrorFormSimpleUtil(errors, touched, "email")}
            />

            <Input
              placeholder={data.formSection.fields.phonePlaceholder}
              variant="Simple"
              value={values.phone}
              onChange={handleChange("phone")}
              onBlur={handleBlur("phone")}
              error={setErrorFormSimpleUtil(errors, touched, "phone")}
              success={!setErrorFormSimpleUtil(errors, touched, "phone")}
            />

            <Input
              placeholder={data.formSection.fields.servicePlaceholder}
              variant="Simple"
              value={values.service}
              onChange={handleChange("service")}
              onBlur={handleBlur("service")}
              error={setErrorFormSimpleUtil(errors, touched, "service")}
              success={!setErrorFormSimpleUtil(errors, touched, "service")}
            />

            <Input
              placeholder={data.formSection.fields.direccionPlaceholder}
              variant="Simple"
              value={values.address}
              onChange={handleChange("address")}
              onBlur={handleBlur("address")}
              error={setErrorFormSimpleUtil(errors, touched, "address")}
              success={!setErrorFormSimpleUtil(errors, touched, "address")}
            />

            <Input
              placeholder={data.formSection.fields.messagePlaceholder}
              variant="Textarea" // 👈 esta es la clave para renderizarlo como textarea
              value={values.message}
              onChange={handleChange("message")}
              onBlur={handleBlur("message")}
              error={setErrorFormSimpleUtil(errors, touched, "message")}
              success={!setErrorFormSimpleUtil(errors, touched, "message")}
            />


            <Button
              text={loading ? "Enviando..." : data.formSection.buttonText}
              action={() => handleSubmit(values)}
              disabled={!isValid || loading}
              fill
              color="yellow"
              textColor="black"
            />
          </div>

        </div>
        <div className="footer-info col-md-3">
          <h3>{data.infoSection.title}</h3>
          <ul>
            {data.infoSection.links.map((link, index) => (
              <li key={index}>
                <a href={link.href}>{link.text}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-contact col-md-3">
          {/* <div className='footer-contact-container'>
            <h3>{data.contactSection.title}</h3>
            {data.contactSection.details.map((detail, index) => (
              <div key={index} className="contact-detail">
                <div className='icon'>{detail.svg}</div>
                <span>{detail.value}</span>
              </div>
            ))}
          </div> */}
        </div>
      </div>
      <div className="footer-socials">
        <div className='container-social-medias'>
          <h3 dangerouslySetInnerHTML={{ __html: data.contactSection.socialTitle }}></h3>
          <div className='content-footer-socials'>
            {data.contactSection.socials.map((social, index) => (
              <a key={index} href={social.href} className={`icon ${social.platform}`}>
                {social.svg}
              </a>
            ))}
          </div>
        </div>
        <div class="footer-contact-container-numbers">
          <h3>CONTACTO</h3>
          <div class="footer-container-number">
            <span class="contact-number">+52 554 859 57 59</span>
            <span class="location">CENTRO</span>
          </div>
          <div class="footer-container-number">
            <span class="contact-number">+52 229 413 10 73</span>
            <span class="location">SURESTE</span>
          </div>
          <div class="footer-container-number">
            <span class="contact-number">+52 331 112 79 46</span>
            <span class="location">OCCIDENTE</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>{bottomText}</span>
      </div>
    </footer>
  );
};

export default Footer;
